export const getVimeoLiveStreamEmbedURL = (videoId: string, unlistedHash: string | undefined) =>
  `https://vimeo.com/event/${videoId}/embed${unlistedHash ? `/${unlistedHash}` : ''}`
